import { Modal } from "./Modal";
import { GhostButton, ActionButton } from "./Primitives";

/** Site deactivation status picker — active / paused / ended. */
export default function SiteDeactivateModal({ site, status, onStatusChange, onCancel, onConfirm }) {
  if (!site) return null;
  const OPTIONS = [
    { v: "active", label: "Active", hint: "Currently operating" },
    { v: "paused", label: "Paused", hint: "Temporarily halted · no future shifts cancelled" },
    { v: "ended", label: "Ended", hint: "Closed permanently · CANCELS all future shifts" },
  ];
  return (
    <Modal title={`Deactivate site — ${site.name}`} onClose={onCancel} testId="site-deactivate-modal">
      <div className="space-y-4">
        <div className="text-xs text-zinc-500">Choose the new status for this site:</div>
        <div className="space-y-2">
          {OPTIONS.map((opt) => (
            <label
              key={opt.v}
              data-testid={`site-deactivate-option-${opt.v}`}
              className={`flex items-start gap-3 p-3 border cursor-pointer transition-colors ${
                status === opt.v ? "border-[#FF3B30] bg-[#FF3B30]/5" : "border-[#27272A] hover:border-zinc-600"
              }`}
            >
              <input
                type="radio"
                name="site-status"
                checked={status === opt.v}
                onChange={() => onStatusChange(opt.v)}
                className="mt-1"
              />
              <div className="min-w-0">
                <div className="text-sm font-semibold uppercase tracking-wider">{opt.label}</div>
                <div className="text-[11px] text-zinc-500 mt-0.5">{opt.hint}</div>
              </div>
            </label>
          ))}
        </div>
        <div className="flex items-center justify-end gap-2 pt-2">
          <GhostButton data-testid="site-deactivate-cancel" onClick={onCancel}>Cancel</GhostButton>
          <ActionButton data-testid="site-deactivate-confirm" onClick={onConfirm}>Update status</ActionButton>
        </div>
      </div>
    </Modal>
  );
}
